import React from 'react'
import "./FAQ.css"
import faq_trut from "../Assets/faq_turtle.png"
import Accordion from 'react-bootstrap/Accordion';

export default function FAQ() {
    return (
        <section className='Main_FAQ ' id='Faq'>
        <div className="ovrly"></div>
            <div className="container">
            <div data-aos="fade-up" className='mt-5 mt-md-5 mt-lg-4'>

           
                <h1 className="section_head upf gor_font text-center">FREQUENTLY ASKED QUESTION</h1>
                {/* <p className='fs-5 upf mt-3 text-white text-center nor_font '>Lorem ipsum dolor sit amet consectetur. Blandit lorem aliquet sodales <br /> proin at molestie tellus amet. Aliquet odio aenean praesent orci vulputate. </p> */}
                </div>
                <h6 className='nor_font upf text-white text-start fs-3 fw-semibold mt-5' data-aos="fade-left">Have any questions? Read popular answers below.</h6>
                <div className='overflow-hidden'>

               
                <Accordion className='mt-5 upf' defaultActiveKey="0">
                    <Accordion.Item data-aos="fade-up"  data-aos-duration="1000" eventKey="0">
                        <Accordion.Header className='nor_font'>Why Staking?

                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>We chose staking over mining to stay green. Bitcoin mining emitted over 85.89 Mt of CO2 during the 2020–2021 period, but our approach significantly reduces pollution. Staking also requires holding coins for a set period, which limits the immediate availability of coins and increases their value. Additionally, staking contributes to the security and efficiency of the blockchain projects you support.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item data-aos="fade-up" data-aos-duration="1200" eventKey="1" className='mt-3'>
                        <Accordion.Header>What is Staking Process?
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>First Year: To appreciate our early supporters, staking will offer up to 182.5% returns in the first 365 days.
                                Second Year: The staking percentage will adjust to the global inflation rate. Stakers who hold for longer than six months will receive an additional bonus.
                            </p>
                            <p className='acc_para nor_font'>Fair Competition: Staking will be available once the coin is officially launched, ensuring a fair competition for all participants.

                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item  data-aos="fade-up" data-aos-duration="1400" eventKey="2 " className='mt-3'>
                        <Accordion.Header>How to Stake?
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>Connect your wallet and select how much $RBT.network you want to stake.

                            </p>
                            <p className='acc_para nor_font'>Fair Competition: After completing a 24-hour staking period, your earnings will appear in your "honey pot."


                            </p>
                            <p className='acc_para nor_font'>Canceling your stake is cost-free.



                            </p>
                            <p className='acc_para nor_font'>Staking can last up to one year; you choose how much, when, and for how long to stake.</p>
                            <p className='acc_para nor_font'>The minimum staking period is 7 days, and the maximum is one year.
                            </p>
                            <p className='acc_para nor_font'>Our self-balancing staking system will help stabilize the ecosystem, adjusting yearly to inflation rates. After the staking period ends, staking will no longer be valid to maintain coin stability. Before the new year, our team will analyze upcoming inflation and adjust accordingly, with updates provided on our website and social media.

                            </p>
                            <p className='acc_para nor_font'>The staking system will help stabilize our coin, preventing market overflow and preserving its value.


                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item data-aos="fade-up" data-aos-duration="1600" eventKey="3 " className='mt-3'>
                        <Accordion.Header>Purpose of $RBT.network Coin
?

                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>The primary goal of $RBT.network Coin is to build a dedicated community of passionate believers in our innovative approach. We aim to create a unique cryptocurrency platform where players can wager, participate in tournaments, and win exciting prizes. Our ultimate vision is to collaborate with games worldwide, introducing a new way to compete and engage.

                            </p>
                         
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item data-aos="fade-up" data-aos-duration="1800" eventKey="4" className='mt-3'>
                        <Accordion.Header>What is Price Stability?


                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>The primary goal of $RBT.network Coin is to build a dedicated community of passionate believers in our innovative approach. We aim to create a unique cryptocurrency platform where players can wager, participate in tournaments, and win exciting prizes. Our ultimate vision is to collaborate with games worldwide, introducing a new way to compete and engage.

                            </p>
                         
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item data-aos="fade-up" data-aos-duration="1900"  eventKey="5" className='mt-3'>
                        <Accordion.Header>What is Liquidity Provision?


                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='acc_para nor_font'>Liquidity provision refers to the process of adding funds (typically in pairs, like <span className='fw-bold' style={{color:"#E647BF"}}>

                                $RBT.network </span>  and another token) to a liquidity pool on a decentralized exchange. This pool enables smooth trading by ensuring there are enough assets available for buyers and sellers.

                            </p>
                         
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                </div>
            </div>
            <img src={faq_trut} className='faq_tur  ' alt="" />

        </section>
    )
}
